import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/pranava-wellness/src/app/components/HeroSection.tsx");
